import { FC, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { MainLayout } from 'views/layouts'
import { TextArea, ModulesQuestionContainer } from './styled'
import { Button } from '../../../../../../components/UI/Buttons'
import Input from '../../../../../../components/UI/TextInput'
import Select from 'views/components/UI/Select'
import TitleDiv from 'views/components/UI/TitleDiv'
import { fetchEditBetesaTalent } from '../../../services/fetch-betesa-talents'
import { Action } from '../../../store'
import { QUADRANT_OPTIONS } from '../../../constants'
import { useNotification } from 'lib/context/notification.context'
import { Response } from '../../../store'

const EditTalent: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const data = location.state?.props

  const { getError, getSuccess, getWarning } = useNotification()
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)

  const newTalentSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required('El nombre del talento es obligatorio')
      .test('no-whitespace', 'El campo no puede contener solo espacios', (value) => (value ? value.length > 0 : false)),
    quadrant: Yup.string().required('Debes asignar un cuadrante'),
    description: Yup.string()
      .trim()
      .required('Debes ingresar una descripción')
      .test('no-whitespace', 'El campo no puede contener solo espacios', (value) => (value ? value.length > 0 : false)),
  })

  const onSubmit = (values: Action) => {
    let body
    if (!values.description) {
      body = {
        name_spa: values.name,
        category: values.quadrant,
      }
    } else {
      body = {
        name_spa: values.name.trim(),
        category: values.quadrant,
        description_spa: values.description.trim(),
      }
    }

    fetchEditBetesaTalent(data?.id, body)
      .then((res: Response) => {
        if (res.status === 'OK' || res.status === 'success') {
          getSuccess('Talento actualizado correctamente')
          navigate(-1)
        } else {
          console.error('Error creating super admin')
          getWarning('No fue posible crear la cuenta')
        }
      })
      .catch(() => {
        getError('No se pudo actualizar el talento')
      })
  }

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Editar talento</h2>
      </TitleDiv>
      <Formik
        validateOnChange={true}
        validateOnMount={true}
        validationSchema={newTalentSchema}
        onSubmit={(values, { resetForm }) => {
          if (!isUploading) {
            setIsUploading(true)
            setButtonDisabled(true)
            onSubmit({
              name: values.name,
              quadrant: values.quadrant,
              description: values.description,
              competenceId: values.competenceId,
            })
            setTimeout(() => {
              setButtonDisabled(false)
              resetForm()
              setIsUploading(false)
            }, 1000)
          }
        }}
        initialValues={{
          name: data.name,
          quadrant: data.qudrant,
          description: data.description || '',
          competenceId: data.id,
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, errors, dirty }) => (
          <>
            <ModulesQuestionContainer>
              <Input
                value={values.name}
                type="text"
                name="name"
                label="Nombre"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Select
                label="Cuadrante asociado"
                options={QUADRANT_OPTIONS}
                value={values.quadrant}
                hideNeverChoice={true}
                onChange={(e) => {
                  handleChange('quadrant')(e.toString())
                }}
              />
            </ModulesQuestionContainer>
            <TextArea
              placeholder="Descripción general del talento"
              onChange={({ target }) => setFieldValue('description', target.value)}
              value={values.description}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: 35,
                marginTop: 40,
                alignItems: 'baseline',
              }}
            >
              <span
                style={{ fontWeight: 'bold', color: '#2D749C', cursor: 'pointer' }}
                onClick={() => {
                  navigate(-1)
                }}
              >
                Atrás
              </span>

              <Button
                style={{
                  width: 162,
                  height: 52,
                  padding: '0 20px',
                  borderRadius: 8,
                  color: '#fff',
                  border: 'none',
                }}
                disabled={isSubmitting || Object.keys(errors).length > 0 || buttonDisabled || !dirty}
                type="submit"
                onClick={handleSubmit}
              >
                Guardar
              </Button>
            </div>
          </>
        )}
      </Formik>
    </MainLayout>
  )
}
export default EditTalent
